<template>
  <a :href="href" :class="{ disabled: disabled, 'text-gray-500': disabled }">
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: "Anchor",
  props: {
    href: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  cursor: default;
}
</style>
